import {CLStore} from 'common/src/redux/store';
import {CompWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import {FORMAT_QUERY_KEY} from 'common/src/modules/creativeTemplates/creativeTemplates.consts';
import getUrlQueryParamValue from 'common/src/utils/urlUtils/getUrlQueryParamValue/getUrlQueryParamValue';

export default function getFormatComps(
  store: CLStore,
): Record<string, CompWithWorkingProps> | null {
  const state = store.getState();
  const formatMoviesState = state.creativeTemplatePage.formatMovies;
  const activeFormat = getUrlQueryParamValue<string>(FORMAT_QUERY_KEY);

  if (!activeFormat || !formatMoviesState.movies[activeFormat]) {
    return null;
  }

  return formatMoviesState.movies[activeFormat];
}
